// browser id for communications device
export const DEVICE_ID_DEFAULT = 'default';
export const DEVICE_ID_COMMUNICATIONS = 'communications';
// id of the faked audio device for "all devices"
export const DEVICE_ID_ALL = 'all';
